module.exports = __webpack_public_path__ + "img/shipin.ab4174fb.jpg";